import type { Benefit } from '../types/content';

export const benefits: Benefit[] = [
  {
    label: 'Confidence',
    title: 'Through achievable progress',
    body: 'Each skill is broken into steps a student can reach. Landing one, then the next, gives confidence something real to stand on.',
  },
  {
    label: 'Focus',
    title: 'Through practice',
    body: 'Class asks students to watch, listen and repeat with care. Over time, paying attention becomes part of how they train.',
  },
  {
    label: 'Persistence',
    title: 'Through challenges',
    body: 'Some kicks don’t work the first time. With coaching, students learn to try again and see what steady effort produces.',
  },
  {
    label: 'Friendship',
    title: 'Through training together',
    body: 'Students train beside familiar faces week after week. Partners cheer each other on, and friendships start on the mat.',
  },
];
